export default __webpack_public_path__ + "static/logo-f58b2f96fe7be11fcea28c558bc3b02e.png";